import { cn } from "@/lib/utils";
import { Albert_Sans } from "next/font/google";
import GoogleSignInButton from "@/components/google-sign-in-button";
import { __ } from "@/lib/i18n/functions";
import SignUpForm from "@/components/organisms/forms/auth/signup-form";

const albert = Albert_Sans({ subsets: ["latin"] });

type SignUpViewProps = {
  resolution: Resolution;
};

const SignUpView = ({ resolution }: SignUpViewProps) => {
  return (
    <article className={cn(albert.className, "mx-auto mt-14 flex w-full max-w-[672px] flex-col gap-12")}>
      <section>
        <div className="w-full">
          <div className="font-cabinet-grotesk text-dark-primary space-y-6">
            <h4 className="text-2xl font-bold">{__("Create my account", resolution.locale)}</h4>
            <GoogleSignInButton locale={resolution.locale} />
            <div className="mt-4">
              <SignUpForm locale={resolution.locale} />
            </div>
          </div>
        </div>
      </section>
    </article>
  );
};

export default SignUpView;
